import { render, staticRenderFns } from "./ModalKomchatCoinRemaining.vue?vue&type=template&id=3f6148a0&"
import script from "./ModalKomchatCoinRemaining.vue?vue&type=script&lang=js&"
export * from "./ModalKomchatCoinRemaining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports